import { ReactNode } from 'react';
import { Box } from '@chakra-ui/react';
import { Text } from 'components/elements/Text';
import { FlexColumn } from 'components/layout/FlexColumn/FlexColumn';

type Props = {
  children: ReactNode;
  label: string | ReactNode;
  description?: string;
  bgColor?: string;
  bWidth?: string;
  sx?: object;
};

export const Section = ({ label, description, children, bgColor, bWidth, sx }: Props) => {
  return (
    <FlexColumn
      sx={{
        p: 8,
        borderRadius: 24,
        borderWidth: bWidth || 1,
        backgroundColor: bgColor || 'brand.grey-lighter',
        width: '100%',
        maxWidth: '600px',
        ...sx,
      }}
    >
      <FlexColumn sx={{ mb: 4 }}>{children}</FlexColumn>
      {typeof label === 'string' ? (
        <Text sx={{ mt: '2rem', mb: '2rem', fontWeight: '500', fontSize: '2rem' }}>
          {label}
        </Text>
      ) : (
        <Box>{label}</Box>
      )}

      <Text>{description}</Text>
    </FlexColumn>
  );
};
